module.exports = __webpack_public_path__ + "static/PrivacyandCookiesPolicy-5fee73b745c0152c9f394bfa188ef83c.pdf";